"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var generateRandomString = function generateRandomString() {
  var array = new Uint32Array(28);
  window.crypto.getRandomValues(array);
  return Array.from(array, function (dec) {
    return "0".concat(dec.toString(16)).substr(-2);
  }).join('');
};

var _default = generateRandomString;
exports.default = _default;